import * as React from 'react';
import { MergeStylesRootContext } from '../contexts/MergeStylesRootContext';
export var useMergeStylesHooks = function () {
    var ctx = React.useContext(MergeStylesRootContext);
    return {
        useAdoptedStylesheet: ctx.useAdoptedStylesheet,
        useAdoptedStylesheetEx: ctx.useAdoptedStylesheetEx,
        useShadowConfig: ctx.useShadowConfig,
        useMergeStylesShadowRootContext: ctx.useMergeStylesShadowRootContext,
        useHasMergeStylesShadowRootContext: ctx.useHasMergeStylesShadowRootContext,
        useMergeStylesRootStylesheets: ctx.useMergeStylesRootStylesheets,
        useWindow: ctx.useWindow,
        useStyled: ctx.useStyled,
    };
};
//# sourceMappingURL=useMergeStylesHooks.js.map